import React from 'react';
import profileSetup from './profileSetupIcon.svg'
import styled from "styled-components";

const ProfileSetupIcon = ({width, height, isMobile}) => {
  return (
    <StyledImg width={width || "106"} height={height || "112"} src={profileSetup} isMobile={isMobile}/>
  )
};

export default ProfileSetupIcon;

const StyledImg = styled.img`
  ${props => props.isMobile ? "margin-bottom: 8px; margin-top: 12px;" : ""}
`;